import { render, staticRenderFns } from "./TopbarAuth.vue?vue&type=template&id=31c4cc22&scoped=true&"
import script from "./TopbarAuth.vue?vue&type=script&lang=js&"
export * from "./TopbarAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c4cc22",
  null
  
)

export default component.exports